module.exports = __webpack_public_path__ + "a768e7de/img/note-list-icon.961c1485.svg";